(function () {
  'use strict';

  if (window.__kkLogoMarqueeControllerAttached) return;
  window.__kkLogoMarqueeControllerAttached = true;

  var selector = '[data-kk-logo-marquee]';

  function initialize(root) {
    if (!root || root.dataset.kkLogoMotionReady === 'true') return;

    var track = root.querySelector('.kk-home-logo-marquee__track');
    var sourceGroup = track && track.querySelector('.kk-home-logo-marquee__group:not([data-kk-logo-marquee-clone])');
    if (!track || !sourceGroup) return;

    root.dataset.kkLogoMotionReady = 'true';

    var hoverRate = Number.parseFloat(root.dataset.hoverRate) || 0.65;
    var reducedMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var sectionVisible = !('IntersectionObserver' in window);
    var playbackRate = 1;
    var initialized = Boolean(track.querySelector('[data-kk-logo-marquee-clone]'));
    var visibilityObserver = null;

    function getAnimation() {
      if (!track.getAnimations) return null;
      return track.getAnimations().find(function (item) {
        return item.animationName === 'kk-home-logo-marquee-scroll';
      }) || null;
    }

    function initializeTrack() {
      if (initialized || !root.isConnected || !sectionVisible || document.hidden || reducedMotionQuery.matches) return;

      var clone = sourceGroup.cloneNode(true);
      clone.dataset.kkLogoMarqueeClone = '';
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach(function (element) { element.removeAttribute('id'); });
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (element) {
        element.removeAttribute('data-shopify-editor-block');
      });
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (element) {
        element.setAttribute('tabindex', '-1');
      });
      clone.querySelectorAll('img').forEach(function (image) {
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
      });

      track.appendChild(clone);
      track.classList.add('is-ready');
      initialized = true;
      window.requestAnimationFrame(updateMotion);
    }

    function updateMotion() {
      var paused = !sectionVisible || document.hidden || reducedMotionQuery.matches;
      root.dataset.kkMotionPaused = paused ? 'true' : 'false';

      if (!paused && !initialized) initializeTrack();

      var animation = getAnimation();
      if (!animation) return;

      if (paused) {
        animation.pause();
      } else {
        animation.play();
        animation.updatePlaybackRate(playbackRate);
      }
    }

    function setRate(rate) {
      playbackRate = rate;
      updateMotion();
    }

    function handlePointerEnter() { setRate(hoverRate); }
    function handlePointerLeave() { setRate(1); }
    function handleFocusIn() { setRate(hoverRate); }
    function handleFocusOut(event) {
      if (!root.contains(event.relatedTarget)) setRate(1);
    }

    function destroy() {
      if (visibilityObserver) visibilityObserver.disconnect();
      root.removeEventListener('pointerenter', handlePointerEnter);
      root.removeEventListener('pointerleave', handlePointerLeave);
      root.removeEventListener('focusin', handleFocusIn);
      root.removeEventListener('focusout', handleFocusOut);
      document.removeEventListener('visibilitychange', updateMotion);

      if (reducedMotionQuery.removeEventListener) {
        reducedMotionQuery.removeEventListener('change', updateMotion);
      } else if (reducedMotionQuery.removeListener) {
        reducedMotionQuery.removeListener(updateMotion);
      }

      var animation = getAnimation();
      if (animation) animation.pause();
      root.dataset.kkMotionPaused = 'true';
      delete root.__kkLogoMarqueeCleanup;
    }

    root.addEventListener('pointerenter', handlePointerEnter);
    root.addEventListener('pointerleave', handlePointerLeave);
    root.addEventListener('focusin', handleFocusIn);
    root.addEventListener('focusout', handleFocusOut);
    document.addEventListener('visibilitychange', updateMotion);

    if (reducedMotionQuery.addEventListener) {
      reducedMotionQuery.addEventListener('change', updateMotion);
    } else if (reducedMotionQuery.addListener) {
      reducedMotionQuery.addListener(updateMotion);
    }

    if ('IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          sectionVisible = entry.isIntersecting && entry.intersectionRatio > 0;
          updateMotion();
        });
      }, { threshold: [0, 0.01] });
      visibilityObserver.observe(root);
    }

    root.__kkLogoMarqueeCleanup = destroy;

    window.requestAnimationFrame(function () {
      if (!('IntersectionObserver' in window)) {
        sectionVisible = true;
        updateMotion();
        return;
      }

      if (!root.isConnected) {
        destroy();
        return;
      }

      if (initialized) {
        track.classList.add('is-ready');
        updateMotion();
      } else {
        root.dataset.kkMotionPaused = 'true';
      }
    });
  }

  function initializeAll(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches(selector)) initialize(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(initialize);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = [];
    if (event.target.matches && event.target.matches(selector)) roots.push(event.target);
    if (event.target.querySelectorAll) roots = roots.concat(Array.from(event.target.querySelectorAll(selector)));
    roots.forEach(function (root) {
      if (typeof root.__kkLogoMarqueeCleanup === 'function') root.__kkLogoMarqueeCleanup();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); }, { once: true });
  } else {
    initializeAll(document);
  }
}());
